import { authHeader } from '../_helpers';
import axios from 'axios';
import { link } from '../_helpers'
export const userService = {
    login,
    logout,
    getAll,
    forgotPassword,
    setPasswordHandler
};


function setPasswordHandler(data,call) {
    return axios[call](`/users/reset/password/${data.hashCode}/`, data.data)
        .then(response => {
            return response;
        })
}


function login(data) {
    return axios.post(`/analytics/login/`, data)
        .then(handleResponse)
        .then(response => {
            localStorage.setItem('user_email', data.email);
            localStorage.setItem('is_org_admin_main',response.data.is_org_admin)
            localStorage.setItem('is_pa_user_main',response.data.is_pa_user)
            localStorage.setItem('is_success_main',response.data.is_super_admin)
            // If client Id and secrete present in the response, call oAuth to get access_token
            var form_data = new FormData();
            const payload = {
                grant_type: 'password',
                username: data.email,
                password: data.password,
                client_id: response.data.auth_key.client_id,
                client_secret: response.data.auth_key.client_secret
            }
            for (var key in payload) {
                form_data.append(key, payload[key]);
            }

            return axios.post(`${link}/o/token/`, form_data)
                .then(handleResponse)
                .then(responseTokenData => {
                    localStorage.setItem('access_token', responseTokenData.data.access_token);
                    axios.defaults.headers.common = authHeader();
                });
        });


}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch('/users', requestOptions).then(handleResponse);
}

function handleResponse(response) {
    if (response.status === 200) {
        // Check if there are any errors
        // If response object contains message then the credentials are invalid
        if (response.data.message !== undefined) {
            const error = response.data.message;
            return Promise.reject(error);
        }
        return response;
    }
    return response;
}

axios.defaults.headers.common = authHeader();
let token = localStorage.getItem('access_token')

function forgotPassword(data) {
    return axios.post(`/analytics/user/forgot/password/`, data)
        .then(response => {
            return response;
        });
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js